import { useState } from "react";
import {
  Box,
  IconButton,
  useTheme,
  useMediaQuery,
  Button,
  Divider,
  Typography,
} from "@mui/material";
import { Menu, Close } from "@mui/icons-material";
import { useDispatch } from "react-redux";
import { setLogout } from "state";
import { useNavigate } from "react-router-dom";
import FlexBetween from "components/FlexBetween";
import SettingsIcon from "@mui/icons-material/Settings";
import logo from "../assets/rubio-logo.svg";

const Navbar = ({
  displaySettings = false,
  handleClickSettings = () => {},
}) => {
  const [isMobileMenuToggled, setIsMobileMenuToggled] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isNonMobileScreens = useMediaQuery("(min-width: 1000px)");

  const theme = useTheme();
  const background = theme.palette.background.default;
  const border = theme.palette.primary.main;

  return (
    <Box position="sticky" top={0} zIndex={99}>
      <FlexBetween padding="1rem 6%" backgroundColor={background}>
        <img
          onClick={() => navigate("/")}
          style={{ height: "30px", cursor: "pointer" }}
          src={logo}
          alt="green-energy"
        />

        <Typography variant="h5" color="text.primary">
          Plateforme de gestion des prix
        </Typography>

        {/* DESKTOP NAV */}
        {isNonMobileScreens ? (
          <FlexBetween gap="2rem">
            {displaySettings && (
              <IconButton onClick={() => handleClickSettings()}>
                <SettingsIcon />
              </IconButton>
            )}
            <Button
              type="submit"
              onClick={() => dispatch(setLogout())}
              variant="contained"
              color="primary"
            >
              Log Out
            </Button>
          </FlexBetween>
        ) : (
          <IconButton
            onClick={() => setIsMobileMenuToggled(!isMobileMenuToggled)}
          >
            <Menu />
          </IconButton>
        )}

        {/* MOBILE NAV */}
        {!isNonMobileScreens && isMobileMenuToggled && (
          <Box
            position="fixed"
            right="0"
            bottom="0"
            height="100%"
            zIndex="10"
            maxWidth="300px"
            minWidth="150px"
            backgroundColor={background}
            border={`solid 0.5px ${border}`}
            boxShadow={`0px 0px 4px 0px ${border}`}
          >
            {/* CLOSE ICON */}
            <Box display="flex" justifyContent="flex-end" p="1rem">
              <IconButton
                onClick={() => setIsMobileMenuToggled(!isMobileMenuToggled)}
              >
                <Close />
              </IconButton>
            </Box>

            {/* MENU ITEMS */}
            <FlexBetween
              display="flex"
              flexDirection="column"
              justifyContent="center"
              alignItems="center"
              gap="1rem"
            >
              <Button
                type="submit"
                onClick={() => dispatch(setLogout())}
                variant="contained"
                color="primary"
              >
                Log Out
              </Button>
              {displaySettings && (
                <IconButton onClick={() => handleClickSettings()}>
                  <SettingsIcon />
                </IconButton>
              )}
            </FlexBetween>
          </Box>
        )}
      </FlexBetween>
      <Divider
        sx={{ borderColor: theme.palette.primary.main }}
        orientation="horizontal"
      />
    </Box>
  );
};

export default Navbar;
